export { confirmPayment, loadStripeInstance } from './stripeApi';

export { confirmIdBankTransferPayment } from './stripeApi.native';
